import { useMemo } from 'react';
import type { Risk } from '../types/risk.type';

type Cell = { p: number; i: number; count: number };

function isValidPI(n: number | undefined | null) {
    return typeof n === 'number' && n >= 1 && n <= 5;
}

export default function RiskHeatmap({ risks }: { risks: Risk[] }) {
    const cells = useMemo(() => {
        const grid: Record<string, Cell> = {};

        for (let p = 1; p <= 5; p++) {
            for (let i = 1; i <= 5; i++) {
                grid[`${p}-${i}`] = { p, i, count: 0 };
            }
        }
        for (const r of risks) {
            const p = r.probability ?? 0;
            const i = r.impact ?? 0;
            if (isValidPI(p) && isValidPI(i)) {
                grid[`${p}-${i}`].count += 1;
            }
        }
        return Object.values(grid);
    }, [risks]);

    /* 색상 강도 */
    const bg = (p: number, i: number) => {
        const s = p * i;
        if (s >= 15) return 'bg-rose-300';
        if (s >= 8) return 'bg-amber-300';
        if (s >= 1) return 'bg-emerald-300';
        return 'bg-gray-100';
    }


    return (
        <div className="w-full">
            {/* X축 라벨(Impact) */}
            <div className="flex items-end gap-2">
                <div className="w-8" />
                <div className='flex-1 flex gap-2'>
                    {[1, 2, 3, 4, 5].map((i) => (
                        <div key={i} className="flex-1 text-center text-[11px] text-gray-500">
                            Impact {i}
                        </div>
                    ))}
                </div>
            </div>

            {/* Grid (P5 → P1) */}
            {[5, 4, 3, 2, 1].map((p) => (
                <div key={p} className="flex items-center gap-2 mt-1">
                    <div className="w-8 text-[11px] text-gray-500 text-right pr-0.5">P{p}</div>
                    <div className='flex-1 flex gap-2'>
                        {[1, 2, 3, 4, 5].map((i) => {
                            const c = cells.find((x) => x.p === p && x.i === i)!.count;
                            return (
                                <div
                                    key={i}
                                    className={`flex-1 h-10 rounded flex items-center justify-center ${bg(p, i)}`}
                                    title={`P${p} × I${i} : ${c} risks`}
                                >
                                    {/* 칸 안 숫자 */}
                                    <span className="text-xs font-medium">{c || ''}</span>
                                </div>
                            );
                        })}
                    </div>
                </div>
            ))}
        </div>
    );
}

